import editIcon from '@/assets/krea/ic_edit.svg'
import trashIcon from '@/assets/ic_trash.svg'
import eyeIcon from '@/assets/ic_eye_on.svg'

export const FOLDER_PERMISSIONS = {
  read: 1,
  edit: 2,
  owner: 3
}

export const folderPermissionsOptions = {
  read: 1,
  edit: 2,
  removeFolderAccess: 0
}

export const folderPermissionsIcons = {
  read: eyeIcon,
  edit: editIcon,
  removeFolderAccess: trashIcon
}

export const foldersTabs = {
  kimpleFolders: 'kimpleFolders',
  myFolders: 'myFolders',
  sharedWithMe: 'sharedWithMe'
}

export const myFoldersTab = 'myFolders'
export const kimpleFoldersTab = 'kimpleFolders'
export const sharedWithMe = 'sharedWithMe'
